import { StyleSheet } from 'react-native';
import { Background } from 'src/theme-v2/background';
import { Buttons } from 'src/theme-v2/buttons';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Neutrals } from 'src/theme-v2/colors';
import { CornerRadius } from 'src/theme-v2/corner-radius';
import { Spacing } from 'src/theme-v2/spacing';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  totalProductsSummaryTooltipContainer: {
    borderRadius: CornerRadius.Large,
  },
  totalProductsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Background.BackgroundColorBrand,
    paddingVertical: Spacing.Condensed,
    paddingHorizontal: Spacing.Tight,
    gap: Spacing.Tight,
    borderRadius: CornerRadius.ExtraLarge,
    cursor: 'default',
  },
  totalProductsContainerOnDark: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Background.BackgroundColorDefault,
    paddingVertical: Spacing.Condensed,
    paddingHorizontal: Spacing.Tight,
    gap: Spacing.Tight,
    borderRadius: CornerRadius.ExtraLarge,
    cursor: 'default',
  },
  totalProducts: {
    gap: Spacing.Condensed,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Background.BackgroundColorDefault,
    paddingVertical: Spacing.Micro,
    paddingHorizontal: Spacing.Condensed,
    borderRadius: CornerRadius.Small,
  },
  totalProductsOnDark: {
    gap: Spacing.Condensed,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: Buttons.quaternaryOnLight.ButtonQuaternaryOnLightBgDefault,
    paddingVertical: Spacing.Micro,
    paddingHorizontal: Spacing.Condensed,
    borderRadius: CornerRadius.Small,
  },
  totalProductsText: {
    color: ColorTypography.TextColorSecondary,
    ...textLatoStyleDS.BodyBoldMd,
  },
  priceContainer: {
    gap: Spacing.Micro,
    flexDirection: 'row',
    alignItems: 'center',
  },
  estimatedPrice: {
    ...textLatoStyleDS.TitleBoldLg,
    color: Neutrals.neutralGreys.GreyNatural900,
  },
  estimatedPriceDiscounted: {
    color: ColorTypography.TextColorPromo,
  },
  iconInfo: {
    width: 14,
    height: 14,
  },
  originalPrice: {
    ...textLatoStyleDS.BodyRegularSm,
    color: ColorTypography.TextColorPrimary,
    textDecorationLine: 'line-through',
  },
});
